module.exports = __webpack_public_path__ + "img/review-like.fe9b8078.svg";